import {dataAPI} from "services/Api/apiConsumer";

export const Upload = async (file: any) => {
  return await dataAPI.post("upload", file);
};
